<template>
    <div class="table-list biz-task-finished">
        <modal class="delete-house" :display="modalStatus.deleteHouse" @modalStatus="closeModal('deleteHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除房源</h1>
            <div class="content">
                確定刪除“{{this.selectedHouse?this.selectedHouse.houseName:'房源名稱'}}”的房源嗎？<br>記錄刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteHouse()">確認</button>
                <button class="border-button" @click="closeModal('deleteHouse')">取消</button>
            </div>
        </modal>
        <modal class="alarm-orange" :display="modalStatus.editHouse" @modalStatus="closeModal('editHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>無法上架</h1>
            <div class="content">
                目前有進行中的合約，請先更新最快起租日
            </div>
            <div class="btn-group">
                <button class="default-button" @click="toEditPage()">編輯房源</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="address">房源地址</span>
            <span class="rentPrice">租金</span>
            <span class="agent">業務</span>
            <span class="landlord">房東</span>
            <span class="rent-status">出租</span>
            <span class="contract-period">租期</span>
            <span class="tenant">房客</span>
            <span class="view-count">瀏覽次</span>
            <span class="status">狀態</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="HmgtIsLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="houseMgtList.length == 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <ul v-else>
                <li v-for="(item,index) in houseMgtList" :key="index">
                    <span class="address">
                        {{item.address}}
                        <!-- <img v-if="item.hasFilm" src="@/assets/img/icon/film.svg" alt="" srcset="">
                        {{item.address.length >= 17?compressWord(item.address, 15):item.address}}
                        <div v-if="item.address.length >= 17" class="full-word">
                            <span>
                                {{item.address}}
                            </span>
                        </div> -->
                    </span>
                    <span class="rentPrice">{{toCurrency(item.rentPrice)}}</span>
                    <span class="agent">{{item.agentName}}</span>
                    <span class="landlord">{{item.landlordName}}</span>
                    <span class="rent-status">{{item.empty?'未租':'已租'}}</span>
                    <span class="contract-period">
                        <div class="list-group" v-for="(period, periodIndex) in item.inProgressContractList" :key="'period'+periodIndex">
                            {{getFormatDateTime(period.contractBeginTime)}} - {{getFormatDateTime(period.contractEndTime)}}
                        </div>
                    </span>
                    <span class="tenant">
                        <div class="list-group" v-for="(tenant, tenantIndex) in item.inProgressContractList" :key="'tenant'+tenantIndex">
                            {{tenant.tenantName}}
                        </div>
                    </span>
                    <div class="view-count">
                        {{item.houseViewCount}}
                    </div>
                    <span class="status h-align" >
                        <img class="good-house" v-if="item.goodHouse" src="@/assets/img/icon/good_house.svg" alt="">
                        <span class="good-house" v-else>-</span>
                        <span class="put" v-if="item.publish">上架</span>
                        <span class="off" v-else>下架</span>
                        <span class="completed" v-if="item.complete">完善</span>
                        <span class="uncompleted" v-else>未完善</span>
                    </span>
                    <span class="action">
                        <dot-dropmenu @click.native="selected = index">
                            <ul>
                                <li v-if="bizAuth.editHouse.hasRight" @click="selectedHouse = item; editHouse()">編輯房源</li>
                                <li v-else @click="selectedHouse = item; editHouse()">查看房源</li>
                                <li v-if="bizAuth.onOrOffShelf.hasRight && item.complete && !item.publish" @click="selectedHouse = item;setBizHousePublish({houseCid: item.cid, status:'REVEAL'})">上架</li>
                                <li v-if="bizAuth.onOrOffShelf.hasRight && item.publish" @click="selectedHouse = item;setBizHousePublish({houseCid: item.cid, status:'HIDE'})">下架</li>
                                <li v-if="bizAuth.shareHouse.hasRight && item.complete && item.publish" @click="shareHouse(item.cid)">分享</li>
                                <li v-if="bizAuth.previewHouse.hasRight && item.complete" @click="previewHouse(item.cid)">預覽</li>
                                <li v-if="bizAuth.deleteHouse.hasRight" @click="selectedHouse = item; openModal('deleteHouse')">刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'

import {
    apiBizPublishHouse
} from "@/apis/api.js";
export default {
    data () {
        return {
            selected: 0,
            selectedHouse: null,
            modalStatus:{
                deleteHouse: false,
                editHouse: false
            },
        }
    },
    props: {
        state: ''
    },
    // created () {
    //     this.$store.dispatch('getBizHouseMgtListV2')
    //     .then(()=>{
    //         // this.isLoading = false
    //     })
    // },
    watch: {
        // filterByWord:{
        //     handler: function (val) {
        //         if( this.state == 0 ){
        //             this.$store.dispatch('setBizHouseMgtFilterResultTotal', {type: 'all', count: val.length})
        //         }else if( this.state == 1 ){
        //             this.$store.dispatch('setBizHouseMgtFilterResultTotal', {type: 'rented', count: val.length})
        //         }else if( this.state == 2 ){
        //             this.$store.dispatch('setBizHouseMgtFilterResultTotal', {type: 'rent', count: val.length})
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    methods: {
        toEditPage: function () {
            this.$router.push({name: 'bizEditHouse', query: {'cid': this.selectedHouse.cid}})
            this.closeModal('editHouse')
        },
        setFilterTotal: function () {
            if( this.state == 0 ){
                this.filterTotal.all = val.length
            }else if( this.state == 1 ){
                this.filterTotal.rented = val.length
            }else if( this.state == 2 ){
                this.filterTotal.rent = val.length
            }
        },
        setBizHousePublish: function (data) {
            let house = this.selectedHouse;
            if(data.status === 'REVEAL' && !house.publishAvailable){
                this.openModal('editHouse')
                return false
            }

            apiBizPublishHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('getBizHouseMgtListV2')
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})

                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        shareHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('分享房源', { screen_name: '分享房源'})
            this.$store.commit('bizHouseManagement/set_selected_house_cid', houseCid)
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizShareSocialMedia'})
        },
        previewHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('預覽房源', { screen_name: '預覽房源'})
            let routeData = this.$router.resolve({name: 'previewHouse', query: {cid: houseCid, mode: 'preview'}});
            window.open(routeData.href, '_blank');
        },
        editHouse: function (){
            let house = this.selectedHouse;
            // 權限導頁
            if(this.bizAuth.editHouse.hasRight){
                // 編輯權限
                if(house.locked){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '預定中不可編輯',type: 'error', closeBtn: true})
                }else{
                    this.$analyticsBiz.logEvent('編輯房源', { screen_name: '編輯房源'})
                    this.$router.push({name: 'bizEditHouse', query: {'cid': house.cid}})
                }
            }else{
                this.$analyticsBiz.logEvent('查看房源', { screen_name: '查看房源'})
                // 查看權限
                this.$router.push({name: 'bizViewHouse', query: {'cid': house.cid}})
            }
        },
        deleteHouse: function () {
            let houseCid = this.selectedHouse.cid
            this.$analyticsBiz.logEvent('刪除房源', { screen_name: '刪除房源'})
            this.$store.dispatch('deleteBizEditHouse', houseCid)
            .then( () => {
                this.closeModal('deleteHouse')
                this.$store.dispatch('getBizHouseMgtListV2')
            });
        },
        openModal: function (type) {
            let house = this.houseMgtList[this.selected]
            if(type == 'deleteHouse'){
                if(house.arrears){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '當房源有欠款時，不得刪除',type: 'error', closeBtn: true})
                }else{
                    this.$store.commit('modalStatus/set_modal_mode', true)
                    this.modalStatus.deleteHouse = true
                }
            }else if(type == 'editHouse'){
                this.$store.commit('modalStatus/set_modal_mode', true)
                this.modalStatus.editHouse = true
            }
        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            if(type == 'deleteHouse'){
                this.modalStatus.deleteHouse = false
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = false
            }
        },
        isHaveTenant: function (array, filter) {
            for (let i = 0; i < array.length; i++) {
                const element = array[i];
                if(element.tenantName.includes(filter)){
                    return true
                }
            }
        }
    },
    computed: {
      /*
        filterByState: function () {
            return this.houseMgtList.filter((houseItem) => {
                // console.log(houseItem)
                if( this.state == 0 ){
                    return houseItem
                }else if( this.state == 1 ){
                    if( houseItem.empty == 0 ){
                        return houseItem
                    }
                }else if( this.state == 2 ){
                    if( houseItem.empty == 1 ){
                        return houseItem
                    }
                }
            });
        },
        filterByGroup: function () {
            return this.filterByState.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.agentName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByCounty: function () {
            return this.filterBySales.filter((houseItem) => {
                if(this.filterQuery.county){
                    if(houseItem.county === this.filterQuery.county){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((houseItem) => {
                if( this.filterQuery.district){
                    if(houseItem.district === this.filterQuery.district){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByRent: function () {
            return this.filterByDistrict.filter((houseItem) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice){
                            return houseItem
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice && this.filterQuery.rent[1] >= houseItem.rentPrice ){
                            return houseItem
                        }
                    }

                }else{
                    return houseItem
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByRent.filter((houseItem) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == houseItem.houseType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((houseItem) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == houseItem.buildingType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByCompleted: function () {
            return this.filterByBuildingType.filter((houseItem) => {
                // console.log(this.filterQuery.completed)
                // console.log(houseItem.complete)
                if( this.filterQuery.completed ){
                    if( this.filterQuery.completed  == 'completed' && houseItem.complete == true){
                        return houseItem
                    }else if( this.filterQuery.completed  == 'noCompleted' && houseItem.complete == false){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByPublish: function () {
            return this.filterByCompleted.filter((houseItem) => {
                if( this.filterQuery.publish ){
                    if( this.filterQuery.publish == 'publish' && houseItem.publish == true ){
                        return houseItem
                    }else if( this.filterQuery.publish == 'noPublish' && houseItem.publish == false ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByWord: function () {
            return this.filterByPublish.filter((houseItem) => {
                if( this.filterWord ){
                    if( houseItem.houseName.includes(this.filterWord) || houseItem.address.includes(this.filterWord) || houseItem.landlordName != null && houseItem.landlordName.includes(this.filterWord) || this.isHaveTenant(houseItem.inProgressContractList, this.filterWord) ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByEmpty: function () {
            return this.filterByWord.filter((houseItem) => {
                if( this.state == 0 ){
                    return houseItem
                }else if( this.state == 1 ){
                    if( houseItem.empty == 0){
                        return houseItem
                    }
                }else if( this.state == 2 ){
                    if( houseItem.empty == 1){
                        return houseItem
                    }
                }
            });
        },
       */
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            filterWord: 'GET_BIZ_HOUSE_MGT_FILTER_WORD',
            filterQuery: 'GET_BIZ_HOUSE_MGT_FILTER_QUERY',
            houseMgtList: 'GET_BIZ_HOUSE_MGT_LIST',
            HmgtIsLoading: 'GET_BIZ_HOUSE_MGT_LOADING'
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        tableLoading
    }
}
</script>
<style lang="scss" scoped>
    .biz-task-finished{
        margin-bottom: 0px !important;
        #modal.delete-house{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .table-list-body ul li{
            align-items: flex-start;
            .list-group{
                margin-bottom: 8px;
            }
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            position: relative;
            width: 228px;
            margin-right: 0px;
        }
        .table-list-body ul li .address{
            display: flex;
            align-items: center;
            >img{
                margin-right: 1px;
            }
        }
        .table-list-title .rentPrice,
        .table-list-body ul li .rentPrice{
            text-align: right;
            width: 56px;
            margin-right: 24px;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 52px;
            margin-right: 24px;
        }
        .table-list-title .landlord,
        .table-list-body ul li .landlord{
            width: 52px;
            margin-right: 24px;
        }
        .table-list-title .rent-status,
        .table-list-body ul li .rent-status{
            width: 28px;
            margin-right: 24px;
        }
        .table-list-title .contract-period,
        .table-list-body ul li .contract-period{
            width: 164px;
            margin-right: 24px;
        }
        .table-list-title .tenant,
        .table-list-body ul li .tenant{
            width: 52px;
            margin-right: 24px;
        }
        .table-list-title .view-count,
        .table-list-body ul li .view-count{
            width: 42px;
            margin-right: 16px;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            display: flex;
            align-items: center;
            width: 182px;
            margin-right: 30px;
            >span{
                width: 52px;
                height: 26px;
                color: #fff;
                font-size: 12px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .good-house{
                margin-right: 8px;
                color: #292625;
                text-align: left;
            }
            >span.put{
                background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
                margin-right: 8px;
            }
            >span.off{
                background-color: #f3f3f3;
                color: #676362;
                margin-right: 8px;
            }
            >span.completed{
                background-color: #71aae5;
            }
            >span.uncompleted{
                background-color: #ff9275;
            }
        }
    }
    // @media screen and (max-width: 1280px){
    //     .task-finished{
    //         .table-list-title .cover,
    //         .table-list-body ul li .cover{
    //             margin-right: 45px;
    //         }
    //         .table-list-title .task-date,
    //         .table-list-body ul li .task-date{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .house,
    //         .table-list-body ul li .house{
    //             margin-right: 45px;
    //         }
    //         .table-list-title .name,
    //         .table-list-body ul li .name{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .pay-way,
    //         .table-list-body ul li .pay-way{
    //             margin-right: 46px;
    //         }
    //         .table-list-title .status,
    //         .table-list-body ul li .status{
    //             margin-right: 46px;
    //         }
    //         .table-list-title .bonus,
    //         .table-list-body ul li .bonus{
    //             margin-right: 46px;
    //         }
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/listMode/HouseMgtList.vue